import type { DateTimeValue } from '@elfsight/configurator-contracts';
import type { FilterType, FilterValue } from './types';

export type FilterOptions<O = string> = {
  include: O[];
  exclude: O[];
};

export type MappedFiltersType = {
  [key in FilterType]: key extends 'date'
    ? FilterOptions<DateTimeValue<'datetime'>>
    : FilterOptions;
};

export const mapFilters = (
  filters: FilterValue[] | undefined,
  availableFilters: string[]
) => {
  const mappedFilters = availableFilters.reduce<Partial<MappedFiltersType>>(
    (acc, filterName) => {
      acc[filterName as FilterType] = {
        include: [],
        exclude: []
      };

      return acc;
    },
    {}
  );

  if (!filters) {
    return null;
  }

  filters.forEach(({ filterDetails, filterValue }) => {
    if (!filterDetails?.type || !filterDetails?.mode || !filterValue) {
      return;
    }

    const { type, mode } = filterDetails;

    if (!availableFilters.includes(type)) {
      return;
    }

    const transformMode = mode.includes('show') ? 'include' : 'exclude';

    if (type === 'hashtag' && typeof filterValue === 'string') {
      filterValue = filterValue.toLowerCase();

      if (!filterValue.startsWith('#')) {
        filterValue = `#${filterValue}`;
      }
    }

    // @ts-expect-error-next-line Здесь нет несоответствия типов
    mappedFilters[type]![transformMode].push(filterValue);
  });

  return mappedFilters;
};
